import { createClient } from "@supabase/supabase-js";

// 公開設定。anon public key は公開して問題ない（RLSで保護）。
// 本番デプロイで env(VITE_SUPABASE_*) が無い場合のフォールバック既定値を埋め込む。
const FALLBACK_URL = "https://orryzqsvunvpiwxxibhy.supabase.co";
const FALLBACK_ANON =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ycnl6cXN2dW52cGl3eHhpYmh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA3NzQ5MDMsImV4cCI6MjA5NjM1MDkwM30.psWMzY6pgIiryVXTDD1455XAAC2p4LYXnGHymomG1Zw";

const url = (import.meta.env.VITE_SUPABASE_URL as string) || FALLBACK_URL;
const anon = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || FALLBACK_ANON;

export const SUPABASE_URL = url;
export const SUPABASE_ANON_KEY = anon;

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // OAuth(Google等)のリダイレクト後にURLからセッションを自動検出・交換（PKCE）
    detectSessionInUrl: true,
    // navigator.locks デッドロック回避：パススルーlock（単一タブ運用前提）
    lock: <R>(_name: string, _acquireTimeout: number, fn: () => Promise<R>): Promise<R> => fn(),
  },
});
